import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { SnackbarContent, SnackbarKey, useSnackbar } from 'notistack'
import { NotificationCard, Row, NotificationIcon } from './components'
import { NotificationDetail } from '@/types'
import { IconButton, Stack } from '@mui/material'
import { secondaryText, leastText } from '@/constant'
import Text from '@/components/Text'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@/components/Button'

export interface CustomNotificationProps {
  message: NotificationDetail;
  id: SnackbarKey;
}

const ForwardCompoennt = (
  props: CustomNotificationProps,
  ref: React.Ref<HTMLDivElement>
) => {
  const { message, id } = props
  const { closeSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const handleClose = useCallback(
    (id: SnackbarKey) => () => {
      closeSnackbar(id)
    },
    [closeSnackbar]
  )

  const onCloseNotification = useCallback(
    (message: NotificationDetail) => () => {
      navigate(
        `/console/personal?tab=1&messageId=${message?.id}`
      )

      closeSnackbar(id)
    },
    [closeSnackbar, id, navigate]
  )

  return (
    <SnackbarContent ref={ref} role="alert">
      <NotificationCard>
        <Row sx={{ justifyContent: 'space-between' }}>
          <Text
            weight="bold"
            size="xs"
            sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <NotificationIcon />
            消息
          </Text>
          <IconButton sx={{ borderRadius: '4px' }} onClick={handleClose(id)}>
            <CloseIcon sx={{ fontSize: '16px', color: '#666666' }} />
          </IconButton>
        </Row>
        <Stack sx={{ marginLeft: '32px' }}>
          <Text weight="regular" size="xs" sx={{ color: secondaryText }}>
            {message?.simple_text}
          </Text>
          <Text weight="regular" size="xs" sx={{ color: leastText }}>
            {message?.created_at}
          </Text>
        </Stack>

        <Row sx={{ justifyContent: 'flex-end' }}>
          {message?.id && (
            <Button type="text" onClick={onCloseNotification(message)}>
              查看详情
            </Button>
          )}
        </Row>
      </NotificationCard>
    </SnackbarContent>
  )
}

const NotificationsComponent = React.forwardRef<
  HTMLDivElement,
  CustomNotificationProps
>(ForwardCompoennt)

export const enqueueNotification = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { enqueueSnackbar } = useSnackbar()

  const pushNotification = (message: NotificationDetail) => {
    enqueueSnackbar(message?.simple_text, {
      content: (key) => {
        return <NotificationsComponent id={key} message={message} />
      },
    })
  }
  return pushNotification
}

export default NotificationsComponent
